import React, { useEffect } from 'react';
import { IoClose } from "react-icons/io5";

const Translator = ({ show, onClose }) => {
  useEffect(() => {
    const scriptId = "google-translate-script";

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          layout: window.google.translate.TranslateElement.InlineLayout.VERTICAL,
        },
        "google_translate_element"
      );
    };

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    } else if (window.google && window.google.translate) {
      window.googleTranslateElementInit();
    }

    return () => {
      const translateContainer = document.getElementById("google_translate_element");
      if (translateContainer) {
        translateContainer.innerHTML = "";
      }
    };
  }, []);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      /* Hide Google Branding */
      .goog-logo-link, .goog-te-gadget span, .goog-te-banner-frame {
        display: none !important;
      }
      
      /* Centered Box */
      .language-selector-box {
        width: 100% !important;
        max-width: 190px !important;
        height: 20px !important;
        padding: 26px !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        border: 1px solid #ddd !important;
        border-radius: 6px !important;
        background: #f9fafb !important;
        cursor: pointer !important;
        margin: 0 auto !important;
      }
      
      /* "Select Language" Text */
      .language-text {
        font-size: 8px !important;
        font-weight: 200 !important;
        color: #ffffff !important;
        pointer-events: none !important;
      }
      
      /* Adjust Google Translate Dropdown */
      .goog-te-combo {
        display: block !important;
        width: 100% !important;
        font-size: 14px !important;
        padding: 5px !important;
        background: transparent !important;
        border: none !important;
        color: #091242 !important;
      }
      .goog-te-combo option {
        display: block !important;
        padding: 5px 10px !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const styles = {
    card: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: show ? 'translate(-50%, -50%)' : 'translate(-50%, 100vh)',
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 6px 18px rgba(0,0,0,0.15)',
      padding: '25px',
      zIndex: 1000,
      opacity: show ? 1 : 0,
      transition: 'all 0.3s ease-in-out',
      maxWidth: '350px',
      width: '90%',
      textAlign: 'center',
      border: '1px solid #eaeaea'
    },
    closeButton: {
      position: 'absolute',
      top: '10px',
      right: '10px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      fontSize: '20px',
      color: '#666',
      transition: 'color 0.2s ease',
    },
    centerContainer: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      margin: '15px 0'
    }
  };

  return (
    <div style={styles.card}>
      <button 
        style={styles.closeButton} 
        onClick={onClose}
        aria-label="Close translator"
      >
        <IoClose />
      </button>
      <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#333', marginBottom: '15px' }}>
        Language Preferences
      </h3>
      <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
        Click 'Select Language' to choose your preferred language.
      </p>

      {/* Centered Language Selector Box */}
      <div style={styles.centerContainer}>
        <div className="language-selector-box">
          {/* note a span of text can be here */}
          <div id="google_translate_element"></div>
        </div>
      </div>
    </div>
  );
};

export default Translator;